/**
 * Fixed FUNCAB 2010 question for the landing.
 *
 * The wording is static. Nothing in this file is loaded from a question
 * endpoint, so every visitor gets the same statement and the same five texts.
 *
 * Each choice has only `id` and `text`. Which letter is right stays on the
 * server.
 */

/** Letter ids of the five choices, in display order. */
export type SampleChoiceId = "a" | "b" | "c" | "d" | "e";

/**
 * One alternative. The only fields are `id` and `text`.
 */
export type SampleChoice = {
  readonly id: SampleChoiceId;
  readonly text: string;
};

export const SAMPLE_QUESTION_META =
  "FUNCAB · PM-GO · Cadete PM · 2010 · Direito Constitucional";

export const SAMPLE_QUESTION_STATEMENT =
  "No que concerne à organização do Estado, é correto afirmar que:";

export const SAMPLE_QUESTION_CHOICES = [
  {
    id: "a",
    text: "compete exclusivamente à União cuidar da saúde e assistência pública, e da proteção e garantia das pessoas portadoras de deficiência.",
  },
  {
    id: "b",
    text: "é possível aos Estados editar medidas provisórias para regulamentar a exploração dos serviços de gás canalizado.",
  },
  {
    id: "c",
    text: "compete aos Municípios organizar e prestar, diretamente ou por delegação, o serviço de transporte coletivo de interesse local.",
  },
  {
    id: "d",
    text: "ao Distrito Federal são atribuídas todas as competências legislativas reservadas à União.",
  },
  {
    id: "e",
    text: "é competência privativa da União legislar sobre responsabilidade por dano ao meio ambiente.",
  },
] as const satisfies readonly SampleChoice[];
